import React, { useState, useEffect } from "react";
import { Form } from "../../Components/form";
import { useGlobalContext } from "../../Context/GlobalContext";
import { useNavigationContext } from "../../Context/NavigationContext";
import Notify from "../../Utils/Notify";
import { countryOptions } from "../../Lib/Countries"
import { Logo } from "../../Components/logo";

const Register = () => {
    const { dbManager } = useGlobalContext();
    const { changeLandingView } = useNavigationContext();

    const [firstName, setFirstName] = useState<string>('');
    const [email, SetEmail] = useState<string>('');
    const [country, setCountry] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [passwordConfirm, setPasswordConfirm] = useState<string>('');
    const [countries, setCountries] = useState<{ key: string, value: string }[]>([]);
    const [optedIn, setOptedIn] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        const getCountries = async() => {
            setCountries(await countryOptions());
        }

        getCountries();
    }, []);

    const handleRegister = async () => {
        setLoading(true);
        const registration = await dbManager.register(
            firstName,
            email,
            country,
            password
        );

        if(registration.status !== 204) {
            const response = await registration.json();
            if(
                response.errors 
                && response.errors[0].message === 'Field "email" has to be unique.'
            ) {
                Notify('error', 'Email already in use');
                return;
            }
        }

        if(registration) {
            Notify('success', 'Sign Up successful');
            if(await dbManager.auth(email, password)) {
                changeLandingView('terminal');
            } else {
                changeLandingView('login');
            }
        } else {
            Notify('error', 'Sign Up failed, please try again');
        }
    }

    return (
        <div className="register" style={{width: '40%',  margin: 'auto'}}>
            <Logo />
            <div className="register-container">
                <div 
                    style={{position: 'absolute', top: '10%', right: '10%', fontSize: '5vh', cursor: 'pointer'}}
                    onClick={() => changeLandingView('login')}
                >
                    X
                </div>
                <Form 
                    fields={[
                        { label: 'FIRST NAME', type: 'text', placeholder: 'thomas', setValue: setFirstName, value: firstName },
                        { label: 'EMAIL', type: 'text', placeholder: 'thomas.anderson@neo.com', setValue: SetEmail, value: email },
                        { label: 'COUNTRY', type: 'select', values: countries, placeholder: 'Choose a Country', setValue: setCountry, value: country, filterable: true },
                        { label: 'PASSWORD', type: 'password', placeholder: '******', setValue: setPassword, value: password },
                        { label: 'REPEAT PASSWORD', type: 'password', placeholder: '******', setValue: setPasswordConfirm, value: passwordConfirm },
                        { 
                            label: 'Yes, I would like to recieve updates, special offers, and marketing communications from knog via email', 
                            type: 'checkbox', 
                            placeholder: '', 
                            setValue: setOptedIn,
                            value: optedIn
                        },
                    ]}
                    submit={handleRegister}
                    buttonText="Sign Up"
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default Register;